import { useEffect, useState } from "react";
import {
  ProgressRadial,
  Modal,
  LabeledSelect,
  LabeledInput,
  Button,
} from "@itwin/itwinui-react";
import { useSBEntityResizer } from "../../hooks/useSBEntityResizer/useSBEntityResizer";

export const SBEntityResizerModal = (props: {
  modalIsOpen: boolean;
  setModalIsOpen: (open: boolean) => void;
}) => {
  const { modalIsOpen, setModalIsOpen } = props;
  const [type, setType] = useState("queue");
  const [topic, setTopic] = useState("");
  const [queue, setQueue] = useState("");
  const [maxSizeInMB, setMaxSizeInMB] = useState(1024);

  const [data, loading, error, resize] = useSBEntityResizer();

  useEffect(() => {
    setTopic("");
    setQueue("");
  }, [type]);

  return (
    <Modal
      isOpen={modalIsOpen}
      onClose={() => setModalIsOpen(false)}
      closeOnEsc
      isDismissible
      title={`SB Entity Resizer`}
    >
      <div style={{ width: "900px" }}>
        <LabeledSelect
          label="Type"
          options={[
            { value: "queue", label: "Queue" },
            { value: "topic", label: "Topic" },
          ]}
          value={type}
          onChange={setType}
          style={{ width: "25%", marginBottom: "10px" }}
        />
        {type === "queue" && (
          <div>
            <LabeledInput
              label="Queue"
              value={queue}
              onChange={(event) => {
                setQueue(event.target.value);
              }}
              style={{ width: "50%", marginBottom: "10px" }}
            />
          </div>
        )}
        {type === "topic" && (
          <div>
            <LabeledInput
              label="Topic"
              value={topic}
              onChange={(event) => {
                setTopic(event.target.value);
              }}
              style={{ width: "50%", marginBottom: "10px" }}
            />
          </div>
        )}
        <LabeledSelect
          label="Max Size"
          options={[
            { value: 1024, label: "1 GB" },
            { value: 2048, label: "2 GB" },
            { value: 3072, label: "3 GB" },
            { value: 4096, label: "4 GB" },
            { value: 5120, label: "5 GB" },
          ]}
          value={maxSizeInMB}
          onChange={setMaxSizeInMB}
          style={{ width: "25%", marginBottom: "10px" }}
        />
        {data && <div>{JSON.stringify(data, null, 4)}</div>}
        <Button
          onClick={() => {
            resize(topic, queue, maxSizeInMB);
          }}
        >
          Update Max Size
        </Button>
        {loading && (
          <ProgressRadial indeterminate style={{ marginLeft: "20px" }} />
        )}
      </div>
    </Modal>
  );
};
